import React, { useState } from "react";

export default function Obligations({ obligations , selectedObligation, setSelectedObligation}) {
  if (!obligations || obligations.length === 0) {
    return (
      <div style={{ padding: "0px" }}>
        <p></p>
      </div>
    );
  }

  return (
    <div style={{ padding: "0px" }}>
<div style={{ padding: '8px', fontWeight: 'bold'}}>
        Obligations
      </div>

       {/* Scrollable table */}
            <div
              style={{
                maxHeight: '40vh', // limits the height
                overflowY: 'auto',   // vertical scroll only
              }}
            >
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
          background: "white",
        }}
      >
        <thead>
          <tr>
            <th style={{ border: "1px solid black", padding: "5px" }}>ID</th>
            <th style={{ border: "1px solid black", padding: "5px" }}>Type</th>
            <th style={{ border: "1px solid black", padding: "5px" }}>Trigger</th>
            <th style={{ border: "1px solid black", padding: "5px" }}>Requirement</th>
            <th style={{ border: "1px solid black", padding: "5px" }}>Deadline</th>
          </tr>
        </thead>
        <tbody>
          {obligations.map((obl, index) => (
            <tr key={index}
            onClick={() => setSelectedObligation(obl.id)}
                                    style={{
                                      border: "1px solid black",
                                      cursor: "pointer",
                                      backgroundColor:
                                      selectedObligation === obl.id ? "lightblue" : "transparent",
                                    }}
            >
              <td style={{ border: "1px solid black", padding: "5px" }}>{obl.id}</td>
              <td style={{ border: "1px solid black", padding: "5px" }}>{obl.type}</td>
              <td style={{ border: "1px solid black", padding: "5px" }}>{obl.trigger}</td>
              <td style={{ border: "1px solid black", padding: "5px" }}>{obl.requirement}</td>
              <td style={{ border: "1px solid black", padding: "5px" }}>{obl.deadline}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
        </div>
  );
}